 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781459232556_COV from '@/components/9781459232556_cov'
 import A781459232556_FM01 from '@/components/9781459232556_fm01'
 import A781459232556_TP from '@/components/9781459232556_tp'
 import A781459232556_DED from '@/components/9781459232556_ded'
 import A781459232556_ATA from '@/components/9781459232556_ata'
 import A781459232556_ADC from '@/components/9781459232556_adc'
 import A781459232556_FM02 from '@/components/9781459232556_fm02'
 import A781459232556_CON01 from '@/components/9781459232556_con01'
 import A781459232556_FM03 from '@/components/9781459232556_fm03'
 import A781459232556_CH01 from '@/components/9781459232556_ch01'
 import A781459232556_CH02 from '@/components/9781459232556_ch02'
 import A781459232556_CH03 from '@/components/9781459232556_ch03'
 import A781459232556_CH04 from '@/components/9781459232556_ch04'
 import A781459232556_CH05 from '@/components/9781459232556_ch05'
 import A781459232556_CH06 from '@/components/9781459232556_ch06'
 import A781459232556_CH07 from '@/components/9781459232556_ch07'
 import A781459232556_CH08 from '@/components/9781459232556_ch08'
 import A781459232556_CH09 from '@/components/9781459232556_ch09'
 import A781459232556_CH10 from '@/components/9781459232556_ch10'
 import A781459232556_CH11 from '@/components/9781459232556_ch11'
 import A781459232556_CH12 from '@/components/9781459232556_ch12'
 import A781459232556_CH13 from '@/components/9781459232556_ch13'
 import A781459232556_CH14 from '@/components/9781459232556_ch14'
 import A781459232556_CH15 from '@/components/9781459232556_ch15'
 import A781459232556_COP01 from '@/components/9781459232556_cop01'
 import FOOTNOTE from '@/components/footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781459232556_con01",
 			"name" : "9781459232556_con01",
 			"component" : A781459232556_CON01
 		},
 		{
 			"path" : "/9781459232556_fm03",
 			"name" : "9781459232556_fm03",
 			"component" : A781459232556_FM03
 		},
 		{
 			"path" : "/9781459232556_ch01",
 			"name" : "9781459232556_ch01",
 			"component" : A781459232556_CH01
 		},
 		{
 			"path" : "/9781459232556_ch02",
 			"name" : "9781459232556_ch02",
 			"component" : A781459232556_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js